require('././planCardController');
require('./../../shared/searchDropDown/searchDropDownDirective');

'use strict';

angular.module('app.pricing.plans.planCardDirective', [
  'app.pricing.plans.planCardController',
  'app.shared.searchdDropDown.searchDropDownDirective'
])
  .directive('planCard', ['PRODUCT',
    function (product) {
      return {
        restrict: 'EA',
        templateUrl: 'components/pricing/plans/' + product.Code + '/planCardView.html',
        controller: 'app.pricing.plans.planCardController',
        scope: {
          plan: '<?',
          currentSubscription: '<?',
          cardType: '<',
          plans: '<?',
          useTeams: '<?',
          planTeams: '<?',
          commonPlanAttrs: '<?',
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/pricing/plans/planCardDirective.js